import { useRef } from 'react';
import type { MapRef } from 'react-map-gl';

export const useMapRefs = () => {
  const smallMap = useRef<MapRef>(null);
  const mediumMap = useRef<MapRef>(null);
  const largeMap = useRef<MapRef>(null);

  return { smallMap, mediumMap, largeMap };
};
